/*
 * @Description: 运单管理-外调车、自有车
 * @Author: WangYuhan
 * @Date: 2022-12-26 16:04:45
 * @LastEditTime: 2024-06-05 16:08:35
 * @LastEditors: lijinpeng
 */

import { get, post, put, deleted, prefix } from './base';

/* ************* 外调车 ************* */

// 运单列表
export function waybillWdList(params) {
  return post(`${prefix}waybill/v2/pageList`, params);
}

// 批量操作运单列表分页
export function batchPageList(params) {
  return post(`${prefix}waybill/v2/batch/operation/pageList`, params);
}

// 查询各运单状态的运单数量
export function countByStatus(params) {
  return post(`${prefix}waybill/v2/count/byStatus`, params);
}

// 创建实时运单
export function createWaybill(params) {
  return post(`${prefix}waybill/v2/createWaybill`, params);
}

// 运单详情
export function getByWaybillNo(params) {
  return get(`${prefix}waybill/v2/getByWaybillNo`, params);
}

// 运单详情
export function postWaybillReceiptConfirm(data) {
  return post(`${prefix}waybill/v2/waybillReceiptConfirm`, data);
}

// 最近使用的三条线路
export function recentlyused(params) {
  return get(`${prefix}routeInfo/recently/used`, params);
}

// 运费范围校验
export function freightRange(params) {
  return post(`${prefix}freight/freightRange`, params);
}

// 批量删除运单
export function waybillDeletes(params) {
  return post(`${prefix}waybill/v2/delete/byWaybillNos`, params);
}

// 删除运单
export function waybillDelete(params) {
  return deleted(`${prefix}waybill/v2/delete/byWaybillNo`, params);
}

// 验证上游运单号是否存在
export function checkUpstreamWaybillNo(params) {
  return get(`${prefix}realTimeWaybill/checkUpstreamWaybillNo`, params);
}

// 编辑运单基础信息
export function updateBaseInfo(params) {
  return post(`${prefix}waybill/v2/update/baseInfo`, params);
}

// 实时运单-设置总运费
export function updateTotalFreight(params) {
  return get(`${prefix}freight/updateTotalFreight?${params}`);
}

// 确认装卸货
export function confirmLoadingOrUnV2(params) {
  return post(`${prefix}waybill/v2/confirmLoadingOrUnV2`, params);
}

// 查询手动装/卸货时车辆位置是否在装卸货地电子围栏内
export function getCheckVehicleIsInTheCircle(params) {
  return get(`${prefix}waybill/v2/v2/checkVehicleIsInTheCircle`, params);
}

// 批量申请结算
export function applySettlementList(params) {
  return post(`${prefix}waybill/v2/applySettlementList`, params);
}

// 实时运单-调整费用
export function adjustmentPay(params) {
  return put(`${prefix}freight/adjustmentFreight`, params);
}

// 申请结算
export function applySettlement(params) {
  return post(`${prefix}waybill/v2/applySettlement`, params);
}

// 修改收款人信息
export function changePayInfo(params) {
  return post(`${prefix}waybill/v2/update/waybillPayInfo`, params);
}

// 检验收款人收款上线
export function checkPayeeAmountLimit(params) {
  return post(`${prefix}realTimeWaybill/checkPayeeAmountLimit`, params);
}

// 编辑运单司机
export function waybillDriver(params) {
  return post(`${prefix}waybill/v2/update/waybillDriver`, params);
}

// 编辑运单车辆
export function waybillVehicle(params) {
  return post(`${prefix}waybill/v2/update/waybillVehicle`, params);
}

// 取消结算
export function applyDeleted(settlementId, params) {
  return deleted(`${prefix}waybill/v2/settlement/${settlementId}`, params);
}

// 批量设置总运费
export function updateAllFreight(params) {
  return post(`${prefix}freight/v2/updateTotalFreight`, params);
}

// 保存正确运单
export function saveSuccessImport(params) {
  return get(`${prefix}waybill/v2/saveSuccessImport`, params);
}

// 导出运单模板
export const exportExcelTemplate = `${prefix}waybill/v2/export`;

// 查询运单日志记录
export function waybillRobotLogPageList(params) {
  return get(`${prefix}waybill/v2/waybillRobotLogPageList`, params);
}

// 可领取补贴油款
export function canReceiveSubsidyOil(params) {
  return post(`${prefix}freight/v2/canReceiveSubsidyOil`, params);
}

/* ************* 自有车 ************* */

// 运单列表
export function waybillZyList(params) {
  return get(`${prefix}own/waybill/page`, params);
}

// 自有车运单删除
export function waybillZyDelete(params) {
  return post(`${prefix}own/waybill/delete`, params);
}

// 自有车运单创建
export function createOwnWaybill(params) {
  return post(`${prefix}own/waybill/create`, params);
}

// 查询路线方案
export function getLineScheme(params) {
  return post(`${prefix}own/waybill/getLineScheme`, params);
}

// 保存路线方案
export function saveLineScheme(params) {
  return post(`${prefix}own/waybill/saveLineScheme`, params);
}

// 自有车路线解析
export function getLinePosition(params) {
  return get(`${prefix}own/waybill/getLinePosition`, params);
}

// 查询指定路线
export function getLineBylineSn(params) {
  return post(`${prefix}own/waybill/getLine`, params);
}

// 运单状态统计
export function getstatusStatistic(params) {
  return get(`${prefix}own/waybill/statusStatistic`, params);
}

// 运单详情
export function ownwaybilldetail(params) {
  return get(`${prefix}own/waybill/detail`, params);
}

// 修改运单
export function waybillUpdate(params) {
  return post(`${prefix}own/waybill/update`, params);
}

// 修改运单成本
export function updateCostInfo(params) {
  return post(`${prefix}own/waybill/updateCostInfo`, params);
}

// 删除运单
export function ownwaybillDelete(params) {
  return post(`${prefix}own/waybill/delete`, params);
}

// （PC-移动端公用）确认接单装卸货
export function confirmAcceptAndLoadAndUnLoad(params) {
  return get(`${prefix}own/waybill/confirmAcceptAndLoadAndUnLoad`, params);
}

// 查询成本修改记录
export function getCostUpdateRecord(params) {
  return get(`${prefix}own/waybill/getCostUpdateRecord`, params);
}

// 导出运单模板
export const waybillexport = `${prefix}own/waybill/export`;

// 账目管理-外调运单
export function getTransferAccounts(params) {
  return post(`${prefix}account/pageList`, params);
}

// 账目管理-自有运单
export function ownPageList(params) {
  return post(`${prefix}own/account/pageList`, params);
}

// 账目管理统计-自有运单
export function accountsTotalCost(params) {
  return post(`${prefix}own/waybill/accountsTotalCost`, params);
}

// 开通途省车辆实时轨迹查询业务
export function vehicleWaybillInfo(params) {
  return get(`${prefix}own/waybill/vehicleWaybillInfo`, params);
}

// 车辆实时轨迹查询
export function vehiclePosition(params) {
  return get(`${prefix}own/waybill/vehiclePosition`, params);
}

// 运单匹配ETC行程费用
export function matchWaybillEtcCost(params) {
  return get(`${prefix}own/waybill/matchWaybillEtcCost`, params);
}

// 异常运单处理
export function updateMonitor(params) {
  return post(`${prefix}own/vehicle/updateMonitor`, params);
}

// 运单轨迹异常预警列表(已处理)
export function vehicleMonitorPage(params) {
  return get(`${prefix}own/vehicle/vehicleMonitorPage`, params);
}

// 自有运单确认上传
export function saveSuccessImportUploadFail(params) {
  return get(`${prefix}own/waybill/saveSuccessImportUploadFail`, params);
}

// 匹配最近路线方案
export function matchLineScheme(params) {
  return post(`${prefix}own/waybill/matchLineScheme`, params);
}

// 修改定点油站
export function updateFixedStation(params) {
  return post(`${prefix}own/waybill/updateFixedStation`, params);
}

// 计算定点油站油费
export function calcOilExpenses(params) {
  return post(`${prefix}own/waybill/calcOilExpenses`, params);
}

// 修改运单配置
export function updateSetting(params) {
  return post(`${prefix}own/waybill/updateSetting`, params);
}

export function payOnlyForOil(params) {
  return get(`${prefix}freight/v2/payOnlyForOil`, params);
}

// 账目列表导出
export const accountExportExcel = `${prefix}account/export`;

// 运单申诉 - 徽商
export function postWaybillAppeal(data) {
  return post(`${prefix}waybill/v2/waybillAppeal`, data);
}

// 查询所选装卸货时间内车辆有无轨迹
export function postVehicleTrajectory(data) {
  return post(`${prefix}sinoiov/vehicle/trajectory`, data);
}

// 批量开单
export function createByOrder(orderId, params) {
  return post(`${prefix}waybill/v2/createByOrder/${orderId}`, params);
}

// 通过货物单价计算运费
export function goodsPriceQuantity(params) {
  return get(`${prefix}freight/goodsPriceQuantity`, params);
}

// 修改装卸货时间
export function updateLoadUnloadTime(params) {
  return post(`${prefix}supplement/loadUnloadTime`, params);
}

// 签署合同
export function getContract(params) {
  return get(`${prefix}waybill/v2/transport/contract`, params);
}

// 获取删除运单承诺函
export function getDeleteWaybillPromise(params) {
  return get(`${prefix}contract/shenTongDeleteWaybillContract`, params);
}

// 创建图片下载任务
export function createImageDownloadTask(params) {
  return post(`${prefix}waybill/v2/createImageDownloadTask`, params);
}

// 查询图片下载任务
export function queryImageDownloadTasks(params) {
  return get(`${prefix}waybill/v2/queryImageDownloadTasks`, params);
}

// 清除图片下载任务
export function clearDownloadWaybillImages(params) {
  return post(`${prefix}waybill/v2/clearDownloadWaybillImages`, params);
}

// 过期运单列表
export function expiredWaybillWdList(params) {
  return post(`${prefix}waybill/v2/expired/pageList`, params);
}

// 删除过期运单
export function deleteExpiredWaybill(params) {
  return post(`${prefix}waybill/v2/delete/expired/byWaybillNos`, params);
}
